import { useEnvironmentVariables, useGetCurrentUserSuspenseQuery } from "@workleap-ai/shared";
import { getTrackingIdentifier, init, registerLogRocketInstrumentation } from "@workleap-tracking/logrocket";
import { useEffect } from "react";

export const useLogRocket = () => {
    const { logRocketAppId } = useEnvironmentVariables();
    const { data: { memberId, organizationId, organizationName, isAdmin } } = useGetCurrentUserSuspenseQuery();

    useEffect(() => {
        // Only init on production
        if (logRocketAppId) {
            const trackingIdentifier = getTrackingIdentifier({ generateCookieOnDefault: true, pregeneratedTrackingIdentifier: memberId }) || "";

            init(logRocketAppId);

            registerLogRocketInstrumentation({
                appId: logRocketAppId,
                trackingIdentifier: trackingIdentifier,
                identifyOptions: {
                    userId: memberId,
                    organizationId: organizationId,
                    isMigratedToWorkleap: true,
                    isAdmin,
                    organizationName
                }
            });
        }
    }, [logRocketAppId, memberId, organizationId, organizationName, isAdmin]);
};
